(function() { window.GUID_e81e7496_8ced_4d43_860b_9908b1f68146 = { getGuid: function() { return "e81e7496-8ced-4d43-860b-9908b1f68146"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-matches",
                        callback: function (accordion, e) {
                            const $showFiltersTrigger = accordion.$Header.find(`#filters-of-${accordion.ContentId}`);
                            if ($showFiltersTrigger.length) {
                                const refreshUrl = $showFiltersTrigger.data("refresh-url");
                                if (refreshUrl != null) {
                                    $showFiltersTrigger.offon(`click.filters-of-${accordion.ContentId}`, (e) => {
                                        accordion.PreventExpendCollapseOnce();
                                        if (accordion.IsExpanded) {
                                            accordion.Data.RefreshUrl = refreshUrl;
                                            accordion.RefreshContent();
                                        }
                                    });
                                }
                            }
                            const $horizontalScroller = $(`#active-filters-horizontal-scroller-${accordion.ContentId}`);
                            if ($horizontalScroller.length > 0)
                                accordion.SetContentSticky($horizontalScroller);
                            const $activeFilters = accordion.$Content.find(".main-wall-section-content__active-filter");
                            if ($activeFilters.length > 0) {
                                $activeFilters.offon("click.active-filter-clicked", (e) => {
                                    const $target = $(e.target);
                                    const $filterContainer = $target.closest(".main-wall-section-content__active-filter");
                                    if ($filterContainer.length > 0) {
                                        const cancelUrl = $filterContainer.data("cancel-url");
                                        if (cancelUrl != null &&
                                            typeof cancelUrl === "string" &&
                                            cancelUrl.trim() != "") {
                                            accordion.Data.RefreshUrl = cancelUrl;
                                            accordion.RefreshContent();
                                        }
                                    }
                                });
                            }
                            let $btnSeeFinished = accordion.$Content.find(".button-see-finished");
                            if ($btnSeeFinished.length > 0) {
                                $btnSeeFinished.offon("click.see-finished-clicked", (e) => {
                                    const $target = $(e.target);
                                    const $filterContainer = $target.closest(".button-see-finished");
                                    if ($filterContainer.length > 0) {
                                        const cancelUrl = $filterContainer.data("url");
                                        if (cancelUrl != null &&
                                            typeof cancelUrl === "string" &&
                                            cancelUrl.trim() != "") {
                                            accordion.Data.RefreshUrl = cancelUrl;
                                            accordion.RefreshContent(() => {
                                                CS.Views.MasterPage.ScrollToSection(accordion.$Content);
                                            });
                                        }
                                    }
                                });
                            }
                            CS.DOM.$body.offon("division-selected-" + accordion.ContentId + ".matches-filter", function (e) {
                                let $this = $(e.target);
                                accordion.Data.RefreshUrl =
                                    accordion.Data.RefreshUrl +
                                        "&newDivId=" +
                                        $this.attr("id").replace("div-", "");
                                accordion.RefreshContent();
                            });
                            CS.Controls.Button.Events.Clicked({
                                selector: `.${accordion.ContentId}-button-clear-division`,
                                callback: (button, e) => {
                                    accordion.Data.RefreshUrl =
                                        accordion.Data.RefreshUrl + "&newDivId=-1";
                                    accordion.RefreshContent();
                                },
                            });
                            CS.Controls.Button.Events.Clicked({
                                selector: `.${accordion.ContentId}-button-clear-date`,
                                callback: (button, e) => updateFilter(accordion, e.jqueryEventObject, e.data.extraData),
                            });
                            CS.Controls.Button.Events.Clicked({
                                selector: `.${accordion.ContentId}-button-clear-all`,
                                callback: (button, e) => updateFilter(accordion, e.jqueryEventObject, e.data.extraData),
                            });
                            CS.Controls.Button.Events.Clicked({
                                selector: `.${accordion.ContentId}-button-clear-division`,
                                callback: (button, e) => {
                                    accordion.Data.RefreshUrl =
                                        accordion.Data.RefreshUrl + "&newDivId=-1";
                                    accordion.RefreshContent();
                                },
                            });
                            //if (CommonData.Current.IsNativeApp) {
                            console.log("IsNativeApp export-to-calendar-btn 4");
                            //Controls.Button.Events.Clicked({
                            //    selector: 'body',
                            //    childSelector: '.export-to-calendar-btn',
                            //    callback: (button, e) => {
                            //        console.log('export-to-calendar-btn data ' + e.data + ' ' + JSON.stringify(e));
                            //        let url = e.data.extraData.url;
                            //        console.log('export-to-calendar-btn ' + url);
                            //        OpenFile(JSON.stringify({ fileUrl: url, fileName: 'csevent.ics' }));
                            //    }
                            //});
                            $("body").offon("click.matches-export", ".export-to-calendar-btn-native", (e) => {
                                console.log("export-to-calendar-btn 9 " + e.target);
                                let url = $(e.target)
                                    .closest(".export-to-calendar-btn-native")
                                    .data("url");
                                if (CS.NativeApp.NA_OpenFile(JSON.stringify({ fileUrl: url, fileName: "csevent.ics" }))) {
                                }
                                else {
                                    console.log("export-to-calendar OpenExternalLink " + url);
                                    CS.NativeApp.NA_OpenExternalLink(url);
                                }
                            });
                            //}
                            CS.Controls.CheckBox.Events.CheckboxValueChanged({
                                selector: ".checkbox-" + accordion.ContentId,
                                callback: (checkbox, e) => updateFilter(accordion, e.jqueryEventObject, e.data.extraData),
                            });
                            CS.Controls.DropDown.Events.ListItemClicked({
                                selector: "#dropdown-matches-filters-" + accordion.ContentId,
                                callback: (list, e) => updateFilter(accordion, e.jqueryEventObject, e.data.extraValues),
                            });
                            CS.Controls.DropDown.Events.ListItemClicked({
                                selector: "#dropdown-matches-formats-" + accordion.ContentId,
                                callback: (list, e) => updateFilter(accordion, e.jqueryEventObject, e.data.extraValues),
                            });
                            CS.Controls.DropDown.Events.ListItemClicked({
                                selector: ".dropdown-date-picker-" + accordion.ContentId,
                                callback: (list, e) => updateFilter(accordion, e.jqueryEventObject, e.data.extraValues),
                            });
                            CS.Controls.DropDown.Events.ListItemClicked({
                                selector: "#dropdown-places-" + accordion.ContentId,
                                callback: (list, e) => updateFilter(accordion, e.jqueryEventObject, e.data.extraValues),
                            });
                        },
                    });
                    CS.Controls.Accordion.Events.ContentLoaded({
                        selector: "body",
                        childSelector: ".accordion-matches",
                        callback: function (control, e) {
                            //GoogleAds.BindAds(true);
                            CS.Ads.RefreshDynamicEzoicAds(control.$Container);
                        },
                    });
                    function updateFilter(accordion, e, extraData) {
                        CS.Lag("matches-filter", 50, function () {
                            if (extraData != null) {
                                let { url } = extraData;
                                if (url == null)
                                    url = extraData.Url;
                                if (url != null) {
                                    accordion.Data.RefreshUrl = url;
                                    accordion.RefreshContent();
                                }
                            }
                        });
                    }
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=matches.js.map
